




































































































































import {getDicts} from '@/api/system/dict/data';
import {addSign, listSign, getSign, updateSign, delSign, changeUserStatus} from '@/api/system/signature/signature';
import {selectDictLabel} from '@/utils/ruoyi';
import {getBase64} from '@/utils/index';
import {msgSuccess} from '@/plugins/element';
import {ElForm} from 'element-ui/types/form';
import Vue from 'vue';

export default Vue.extend({
  name: 'Signature',
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      names: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 第三方用户表格数据
      signList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 弹出层标题
      secretKeyTitle: '',
      // 是否显示弹出层
      secretKeyOpen: false,
      // 状态数据字典
      statusOptions: [],
      // 查询参数
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        signId: undefined,
        name: undefined,
        status: undefined
      },
      // 表单参数
      form: {} as any,
      signImgList: [],
      // 表单校验
      rules: {
        signId: [
          {required: true, message: '电子签章唯一标识不能为空', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '电子签章名称不能为空', trigger: 'blur'}
        ],
        signImg: [
          {required: true, message: '电子签章图片不能为空', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    this.getList();
    getDicts('sys_normal_disable').then(response => {
      this.statusOptions = response.data;
    });
  },
  methods: {
    getList() {
      this.loading = true;
      listSign(this.queryParams).then(response => {
          this.signList = response.data.list;
          this.total = response.data.total;
          this.loading = false;
        }
      );
    },

    statusFormat(row) {
      return selectDictLabel(this.statusOptions, row.status);
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        signId: undefined,
        name: undefined,
        status: '0',
        remark: undefined,
        signImg: undefined
      };
      this.resetForm('form');
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageIndex = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm');
      this.handleQuery();
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = '添加电子签章';
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.names = selection.map(item => item.name);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids;
      getSign(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = '修改电子签章信息';
      });
    },
    /** 提交按钮 */
    submitForm: function () {
      (this.$refs['form'] as ElForm).validate(valid => {
        if (valid) {
          if (this.form.id != undefined) {
            updateSign(this.form).then(() => {
              msgSuccess('修改成功');
              this.open = false;
              this.getList();
            });
          } else {
            addSign(this.form).then(() => {
              msgSuccess('新增成功');
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      const names = row.name || this.names;
      this.$confirm('是否确认删除电子签章名称【' + names + '】的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return delSign(ids);
      }).then(() => {
        this.getList();
        msgSuccess('删除成功');
      });
    },
    // 用户状态修改
    handleStatusChange(row) {
      let text = row.status === '0' ? '启用' : '停用';
      this.$confirm('确认要【' + text + '】电子签章【' + row.name + '】吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return changeUserStatus(row.id, row.status);
      }).then(() => {
        msgSuccess(text + '成功');
      }).catch(function () {
        row.status = row.status === '0' ? '1' : '0';
      });
    },

    getSignImg(file, fileList) {
      this.signImgList = fileList.slice(-1);

      const isPNG = file.raw.type === "image/png"
      const isLimit1M = file.raw.size / 1024 / 1024 < 1

      if (!isPNG) {
        this.$message.error('上传图片格式只能是 png');
        return false;
      } else if (!isLimit1M) {
        this.$message.error("上传图片大小不能超过 1M!")
        return false;
      }
      getBase64(file.raw).then(res => {
        this.form.signImg = res;
        (this.$refs['form'] as any).validateField("signImg");
      });
      return true;
    }
  }
});
